/**
 * Local anaesthetic helpers (AACI charting). Pure, no imports, so
 * tests/unit can load this file with node --test. The server recomputes
 * these numbers on save; this is for the live display only.
 */

const isBlank = v => v === null || v === undefined || v === "";
const num = v => (isBlank(v) ? null : Number(v));
const round = (n, d) => Math.round(n * 10 ** d) / 10 ** d;

export const WARNING_RATIO = 0.8;

export function computeAnesthetic({
  carpules,
  carpuleMl,
  mgPerMl,
  maxMgPerKg,
  weightKg,
}) {
  const c = num(carpules);
  const ml = num(carpuleMl);
  const mg = num(mgPerMl);
  const perKg = num(maxMgPerKg);
  const w = num(weightKg);
  const totalMl = c !== null && ml !== null ? round(c * ml, 2) : null;
  const totalMg = totalMl !== null && mg !== null ? round(totalMl * mg, 1) : null;
  const maxMg = w !== null && perKg !== null ? round(w * perKg, 1) : null;
  let level = null;
  if (totalMg !== null && maxMg !== null) {
    if (totalMg >= maxMg) level = "danger";
    else if (totalMg >= WARNING_RATIO * maxMg) level = "warning";
    else level = "ok";
  }
  return { totalMl, totalMg, maxMg, level };
}

export function toAnestheticPayload(value) {
  if (!value || isBlank(value.itemId)) return null;
  return { itemId: Number(value.itemId), carpules: Number(value.carpules) };
}

export function sanitizeTreatmentItem(item) {
  const out = { ...item };
  delete out.allergyAckUid;
  delete out.allergyAckDt;
  if ("anesthetic" in out) {
    out.anesthetic = toAnestheticPayload(out.anesthetic);
  }
  return out;
}

export function anestheticInputError(value) {
  if (!value) return null;
  if (isBlank(value.itemId)) return "กรุณาเลือกยาชา";
  const c = num(value.carpules);
  if (c === null || c < 0.5 || c > 20) return "กรุณาใส่จำนวน carpule (0.5–20)";
  return null;
}
